export default import.meta.ROLLDOWN_FILE_URL_ZKqqjZFR42UTR3PiSkCOqw